import { render, staticRenderFns } from "./basicsgoodAction.vue?vue&type=template&id=ea75b2c0&scoped=true"
import script from "./basicsgoodAction.vue?vue&type=script&lang=js"
export * from "./basicsgoodAction.vue?vue&type=script&lang=js"
import style0 from "./basicsgoodAction.vue?vue&type=style&index=0&id=ea75b2c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea75b2c0",
  null
  
)

export default component.exports